import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

export const projectTreeStyle = style({
    width: 320,
    padding: CommonStyles.Sizes.LargeSpace,
    borderRight: `1px solid ${applyColor(DesignTokens.color.elevation.border.default.subtle, TabStyles.Colors.L6)}`,
});

// TODO: Rename this style when the feature flag is removed
export const projectTreeResizableStyle = style({
    paddingTop: CommonStyles.Sizes.LargeSpace,
    paddingLeft: CommonStyles.Sizes.LargeSpace,
    paddingRight: CommonStyles.Sizes.LargeSpace,
    paddingBottom: 0, // remove bottom padding to make it look nicer when content is scrollable
    borderRight: `1px solid ${applyColor(DesignTokens.color.elevation.border.default.subtle, TabStyles.Colors.L6)}`,
    position: 'relative' as const,
    boxSizing: 'border-box' as const
});

// Resizable Project Tree ================================
// invisible handle for cursor and touch events
export const projectTreeResizeHandleStyle = style({
    position: 'absolute',
    top: 0,
    right: '-6px', // center the 12px wide hitbox on the border
    bottom: 0,
    width: '12px',
    cursor: 'col-resize',
    touchAction: 'none',
    outline: 'none'
});

// set cursor and disable text selection during resize interaction
export const projectTreeResizeGlobalDragStyle = style({
    $unique: true,
    cursor: 'col-resize',
    userSelect: 'none',
    $nest: {
        '& *': { cursor: 'col-resize !important' }
    }
});

// highlight project tree right-side border in light blue when hovered
// (only when feature flag is enabled)
export const projectTreeResizableHoverStyle = style({
    // use box-shadow to avoid thicker border from causing divider to move around
    borderRightColor: applyColor(DesignTokens.color.link.inline.default.hover, CommonStyles.Colors.HyperlinkBlueHover),
    boxShadow: `inset -2px 0 0 ${applyColor(DesignTokens.color.link.inline.default.hover, CommonStyles.Colors.HyperlinkBlueHover)}`
});

// highlight project tree right-side border in darker blue when focused via keyboard
// thicker than hover to provide clear visual distinction
// (only when feature flag is enabled)
export const projectTreeResizableFocusStyle = style({
    // use box-shadow to avoid thicker border from causing divider to move around
    borderRightColor: applyColor(DesignTokens.color.utility.focus.default.default, CommonStyles.Colors.FocusBorderBlue),
    boxShadow: `inset -3px 0 0 ${applyColor(DesignTokens.color.utility.focus.default.default, CommonStyles.Colors.FocusBorderBlue)}`
});

// =======================================================

 export const projectTreeNodeStyle = style({
    width: '100%',
    alignItems: 'center',
    display: 'flex',
    fontSize: 14,
    gap: 5
});

export const projectTreeNodeTextContainerStyle = style({
    position: 'relative',
    flex: '1 1 auto',
    height: '100%'
});

export const projectTreeNodeTextStyle = style({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
  position: 'absolute'
});
